import {Pipe, PipeTransform} from '@angular/core';
import * as luxon from 'luxon';
import {Contract} from '../../models';
import {DateTime} from 'luxon';

@Pipe({
    name: 'interesseMaturate',
})
export class InteresseMaturatePipe implements PipeTransform {

    round = (n, dp) => {
        const h = +('1'.padEnd(dp + 1, '0')); // 10 or 100 or 1000 or etc
        return Math.round(n * h) / h;
    };

    transform(value: Contract, withTotal: boolean = false): number {
        let startDate = DateTime.fromISO(value.startDate);
        let endDate = DateTime.fromISO(value.endDate);

        let now = DateTime.now();

        let checkDate = endDate.diff(now, ['day']);
        let diff;
        if (checkDate.get('day') >= 0) {
            diff = now.diff(startDate, ['years', 'days']);
        } else {
            diff = endDate.diff(startDate, ['years', 'days']);
        }


        
        let years = diff.get('years');
        
        if (isNaN(years) || years < 0 || years == Infinity) {
            return 0;
        }
        let amount = value.amount;
        let total = 0;
        while (years != 0) {
            let x = ((value.percent * amount) / 100);
            total = total + x;
            amount = amount + x;
            years--;
            
        }


        let days = diff.get('days');
        let val = (this.round(days / 365, 2) * ((value.percent * amount) / 100));
        let resp: number = this.round(val + total, 2);
        if (withTotal) {
            return amount + val;
        }
        return resp;

    }

}
